@charset "UTF-8";

/* src/app/builder-screen-beta/inspector/flow-config-modal/flow-config-modal.component.scss */
.flow-config-modal {
  min-width: 650px;
  max-width: 750px;
}
.flow-config-modal h2 {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1890ff;
  font-size: 20px;
  margin: 0;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}
.flow-config-modal h2 mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.flow-config-modal mat-dialog-content {
  padding: 24px;
  min-height: 350px;
  max-height: 70vh;
  overflow-y: auto;
}
.flow-config-modal .flow-config-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.flow-config-modal .flow-config-form .form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.flow-config-modal .flow-config-form .form-field label {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
.flow-config-modal .flow-config-form .form-field label.required::after {
  content: " *";
  color: #ff4d4f;
}
.flow-config-modal .flow-config-form .form-field .help-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 4px;
}
.flow-config-modal .flow-config-form .form-field .full-width {
  width: 100%;
}
.flow-config-modal .flow-config-form .form-field .custom-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
}
.flow-config-modal .flow-config-form .form-field .custom-select:hover {
  border-color: #40a9ff;
}
.flow-config-modal .flow-config-form .form-field .custom-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: none;
}
.flow-config-modal .flow-config-form .form-field .custom-select option {
  padding: 8px;
}
.flow-config-modal .flow-config-form .form-field mat-checkbox ::ng-deep .mat-checkbox-label {
  font-size: 14px;
}
.flow-config-modal .search-box {
  position: relative;
}
.flow-config-modal .search-box .search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px 12px;
  background: white;
  transition: all 0.3s;
}
.flow-config-modal .search-box .search-input-wrapper:hover {
  border-color: #40a9ff;
}
.flow-config-modal .search-box .search-input-wrapper:focus-within {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.flow-config-modal .search-box .search-input-wrapper .search-prefix {
  color: rgba(0, 0, 0, 0.45);
  margin-right: 8px;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.flow-config-modal .search-box .search-input-wrapper .search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  padding: 4px 0;
  background: transparent;
}
.flow-config-modal .search-box .search-input-wrapper .search-input::placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.flow-config-modal .search-box .search-input-wrapper .search-input:disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.flow-config-modal .search-box .search-input-wrapper .search-clear {
  margin-left: 4px;
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.flow-config-modal .search-box .search-input-wrapper .search-clear mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.flow-config-modal .search-box .results-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 4px;
}
.flow-config-modal .search-box .results-list .result-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f0f0f0;
}
.flow-config-modal .search-box .results-list .result-item:last-child {
  border-bottom: none;
}
.flow-config-modal .search-box .results-list .result-item:hover {
  background: #f5f5f5;
}
.flow-config-modal .search-box .results-list .result-item .result-main {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.flow-config-modal .search-box .results-list .result-item .result-main .result-id {
  font-weight: 600;
  color: #1890ff;
  font-size: 12px;
}
.flow-config-modal .search-box .results-list .result-item .result-main .result-name {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  flex: 1;
}
.flow-config-modal .search-box .results-list .result-item .result-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.flow-config-modal .search-box .results-list .result-item .result-meta .result-mktp::before {
  content: "\1f4e6  ";
}
.flow-config-modal .search-box .results-list .result-item .result-meta .result-company::before {
  content: "\1f3e2  ";
}
.flow-config-modal .search-box .results-list .no-results {
  padding: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}
.flow-config-modal .search-box .selected-config {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  margin-top: 8px;
}
.flow-config-modal .search-box .selected-config .selected-icon {
  color: #52c41a;
  font-size: 24px;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.flow-config-modal .search-box .selected-config .selected-info {
  flex: 1;
}
.flow-config-modal .search-box .selected-config .selected-info .selected-main {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 4px;
}
.flow-config-modal .search-box .selected-config .selected-info .selected-main strong {
  color: #1890ff;
}
.flow-config-modal .search-box .selected-config .selected-info .selected-meta {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
.flow-config-modal .search-box .loading-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}
.flow-config-modal .search-box .loading-indicator mat-icon.spin {
  animation: spin 1s linear infinite;
}
.flow-config-modal mat-dialog-actions {
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  gap: 12px;
}
.flow-config-modal mat-dialog-actions button mat-icon {
  margin-right: 4px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.theme-alternate .flow-config-modal h2 {
  color: #40a9ff;
  border-bottom-color: rgba(255, 255, 255, 0.12);
}
.theme-alternate .flow-config-modal mat-dialog-actions {
  border-top-color: rgba(255, 255, 255, 0.12);
}
.theme-alternate .flow-config-modal .form-field label {
  color: rgba(255, 255, 255, 0.85);
}
.theme-alternate .flow-config-modal .form-field .help-text {
  color: rgba(255, 255, 255, 0.45);
}
/*# sourceMappingURL=flow-config-modal.component.css.map */
